import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class RegistrationReportService {
  constructor(private http: HttpUtilService) {}

  RegistrationReport(
    FromDate: string,
    GroupBy: string,
    ToDate: string,
  ): Observable<any> {
    return this.http.post(
      "SalesReportService.asmx/RegistrationReport",
      {
        model: {
          FromDate,
          GroupBy,
          ToDate,
        },
      },
    );
  }
}
